import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { FitterComponent } from './pages/fitter/fitter.component';


const routes: Routes = [
  {
    path: 'fitter',
    component: FitterComponent
  },
  {
    path: 'home',
    component: HomeComponent
  },
  { 
    path: '**',
    redirectTo: 'home'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
